import axios from 'axios'
import pageKeys from '../common/pagekeys'
import store from '@/store'

export default {
    async getSummary() {
        try {
            //My Attendance > Timesheet main page
            const response = await axios.get(`Timesheet/summary`, {
                headers: {
                    'page_key': pageKeys.timesheet
                }
            })            
            return response
        }catch(error){
            console.log('timesheet api getSummary error')
            throw error
        }
    },
    async getSummaryByTeam() {
        try {
            //My Team > Timesheet main page
            const response = await axios.get(`Timesheet/${store.state.selectedTeamId}/summary`, {
                headers: {
                    'page_key': pageKeys.timesheet_team_approver
                }
            })            
            return response
        }catch(error){
            console.log('timesheet api getSummaryByTeam error')
            throw error
        }
    },
    async getSummaryByCompany() {
        try {
            //Time > Timesheet main page
            const response = await axios.get(`Timesheet/summary/company`, {
                headers: {
                    'page_key': pageKeys.timesheet_company_approver
                }
            })            
            return response
        }catch(error){
            console.log('timesheet api getSummaryByCompany error')
            throw error
        }
    },
    async getTimeReportByTeam(cutOffId) {
        try
        {           
            //My Team > Timesheet > Details 
            const response = await axios.get(`Timesheet/${store.state.selectedTeamId}/details/${cutOffId}`, {
                headers: {
                    'page_key': pageKeys.timesheet_team_approver
                }
            })                        
            return response
        }
        catch (error)
        {
            console.log('timesheet api getTimeReportByTeam error')
            throw error
        }
    },
    async getByCutoffByUser(cutoffId) {
        try
        {            
            const response = await axios.get(`Timesheet/${cutoffId}`, {
                headers: {
                    'page_key': pageKeys.timesheet
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('timesheet api getByCutoffByUser error')
            throw error
        }
    },
    async getByCutoffBySelectedUser(cutoffId, userId, pageKey) {
        try
        {            
            const response = await axios.get(`Timesheet/${cutoffId}/${userId}`, {
                headers: {
                    'page_key': pageKey
                }
            })                       
            return response
        }
        catch (error)
        {
            console.log('timesheet api getByCutoffBySelectedUser error')
            throw error
        }
    },
    async getExcelReport(cutOffId, userId, pageKey) {
        try
        {            
            const response = await axios.get(`Timesheet/xls/${cutOffId}/${userId}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Timesheet api getExcelReport error')
            throw error
        }
    },
    async getExcelTeamReport(cutOffId, teamId, pageKey) {
        try
        {            
            const response = await axios.get(`Timesheet/xls/${cutOffId}/team/${teamId}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Timesheet api getExcelTeamReport error')
            throw error
        }
    },
    async upsertTimeReport(data) {
        try
        {            
            const response = await axios.post(`Timesheet`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.timesheet
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('timesheet api upsertTimeReport error')
            throw error
        }
    },
    async approveTimeReport(timeReportId, pageKey) {
        try
        {            
            const response = await axios.post(`Timesheet/${store.state.selectedTeamId}/approve/${timeReportId}`,
            {}, 
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('timesheet api approveTimeReport error')
            throw error
        }
    },
    async rejectTimeReport(timeReportId, pageKey) {
        try
        {            
            const response = await axios.post(`Timesheet/${store.state.selectedTeamId}/reject/${timeReportId}`,
            {}, 
            {
                headers: {
                    'page_key': pageKey
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('timesheet api rejectTimeReport error')
            throw error
        }
    },
    async deleteTimeReport(timeReportId, pageKey) {
        try
        {            
            //using HtttpPost since HttpDelete requires add'l IIS config
            const response = await axios.post(`Timesheet/${store.state.selectedTeamId}/delete/${timeReportId}`,
            {}, 
            {
                headers: {
                    'page_key': pageKey
                }
            })                
            return response
        }
        catch (error)
        {
            console.log('timesheet api deleteTimeReport error')
            throw error
        }
    },
    async getMonthlyByUser(month) {
        try
        {            
            const response = await axios.get(`Timesheet/byuser/monthly/${month}`, {
                headers: {
                    'page_key': pageKeys.timesheet
                }
            })                                    
            return response
        }
        catch (error)
        {
            console.log('timesheet api getMonthlyByUser error')
            throw error
        }
    },    
    async getMonthlyBySelectedUser(user, month) {
        try
        {            
            const response = await axios.get(`Timesheet/byuser/${user}/monthly/${month}`, {
                headers: {
                    'page_key': pageKeys.timesheet
                }
            })                                    
            return response
        }
        catch (error)
        {
            console.log('timesheet api getSummary error')
            throw error
        }
    },
    async getWeeklyByUser(startDate) {
        try
        {            
            const response = await axios.get(`Timesheet/weekly/byuser/${startDate}`, {
                headers: {
                    'page_key': pageKeys.timesheet
                }
            })                                    
            return response
        }
        catch (error)
        {
            console.log('timesheet api getWeeklyByUser error')
            throw error
        }
    }, 
    async getTimeReportByCompany(cutOffId) {
        try
        {            
            const response = await axios.get(`Timesheet/bycompany/${cutOffId}`, {
                headers: {
                    'page_key': pageKeys.timesheet_company_approver
                }
            })                                    
            return response
        }
        catch (error)
        {
            console.log('timesheet api getTimeReportByCompany error')
            throw error
        }
    }, 
}